<template>
    <div class="store">
        <order :type="1"></order>
    </div>
</template>

<script>
    import order from '../../bus/order/index'
    export default {
        name: "index",
        components:{
            order
        }
    }
</script>

<style scoped>

</style>